module.exports = __webpack_public_path__ + "assets/img/order_4.ea1a8f0d.svg";